/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRegimen } from 'app/entities/regimen/regimen.reducer';
import { getEntities as getRegimenCycles } from 'app/entities/regimen-cycle/regimen-cycle.reducer';
import { getEntities as getImageTests } from 'app/entities/image-tests/image-tests.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';
import { createEntity, getEntity, reset, updateEntity } from './regimen-investigation.reducer';

export const RegimenInvestigationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const regimen = useAppSelector(state => state.regimen.entities);
  const regimenCycles = useAppSelector(state => state.regimenCycle.entities);
  const imageTests = useAppSelector(state => state.imageTests.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const regimenInvestigationEntity = useAppSelector(state => state.regimenInvestigation.entity);
  const loading = useAppSelector(state => state.regimenInvestigation.loading);
  const updating = useAppSelector(state => state.regimenInvestigation.updating);
  const updateSuccess = useAppSelector(state => state.regimenInvestigation.updateSuccess);
  const associationTypeValues = Object.keys(AssociationType);

  const handleClose = () => {
    navigate(`/regimen-investigation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRegimen({}));
    dispatch(getRegimenCycles({}));
    dispatch(getImageTests({}));
    dispatch(getDiagLabPanels({}));
    dispatch(getLabTestItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cycleNumber !== undefined && typeof values.cycleNumber !== 'number') {
      values.cycleNumber = Number(values.cycleNumber);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...regimenInvestigationEntity,
      ...values,
      regimen: regimen.find(it => it.id.toString() === values.regimen?.toString()),
      cycle: regimenCycles.find(it => it.id.toString() === values.cycle?.toString()),
      imageTest: imageTests.find(it => it.id.toString() === values.imageTest?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      labTestItem: labTestItems.find(it => it.id.toString() === values.labTestItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          associationType: 'PATHOLOGY',
          ...regimenInvestigationEntity,
          regimen: regimenInvestigationEntity?.regimen?.id,
          cycle: regimenInvestigationEntity?.cycle?.id,
          imageTest: regimenInvestigationEntity?.imageTest?.id,
          panel: regimenInvestigationEntity?.panel?.id,
          labTestItem: regimenInvestigationEntity?.labTestItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.regimenInvestigation.home.createOrEditLabel" data-cy="RegimenInvestigationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.regimenInvestigation.home.createOrEditLabel">
              Create or edit a RegimenInvestigation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="regimen-investigation-id"
                  label={translate('tinyMedicRestApp.regimenInvestigation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.cycleNumber')}
                id="regimen-investigation-cycleNumber"
                name="cycleNumber"
                data-cy="cycleNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.associationType')}
                id="regimen-investigation-associationType"
                name="associationType"
                data-cy="associationType"
                type="select"
              >
                {associationTypeValues.map(associationType => (
                  <option value={associationType} key={associationType}>
                    {translate(`tinyMedicRestApp.AssociationType.${associationType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.noteOrInstructions')}
                id="regimen-investigation-noteOrInstructions"
                name="noteOrInstructions"
                data-cy="noteOrInstructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.active')}
                id="regimen-investigation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.cursor')}
                id="regimen-investigation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.lastUpdated')}
                id="regimen-investigation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.microSec')}
                id="regimen-investigation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenInvestigation.timestampEntry')}
                id="regimen-investigation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="regimen-investigation-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.regimenInvestigation.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {regimen
                  ? regimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-investigation-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.regimenInvestigation.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {regimenCycles
                  ? regimenCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-investigation-imageTest"
                name="imageTest"
                data-cy="imageTest"
                label={translate('tinyMedicRestApp.regimenInvestigation.imageTest')}
                type="select"
              >
                <option value="" key="0" />
                {imageTests
                  ? imageTests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-investigation-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.regimenInvestigation.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-investigation-labTestItem"
                name="labTestItem"
                data-cy="labTestItem"
                label={translate('tinyMedicRestApp.regimenInvestigation.labTestItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/regimen-investigation" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RegimenInvestigationUpdate;
